import { observer } from "mobx-react";
import { observable, computed, action, autorun, toJS } from "mobx";
import { config } from "src/config";
import { authStore } from 'src/modules/auth';

export interface IPermissionInfo {
    permission_id: number;
    PermissionCategory: string;
    PermissionType: string;
    PermissionDescription: string;
    [key: string]: string | number | undefined;
};

export interface IPermissionFullInfo {
    permission_id: number;
    PermissionCategory: string;
    PermissionType: string;
    PermissionDescription: string;
    ActiveRoleList: IPermissionRole[];
};

export interface IPermissionRole {
    role_id: number;
    Active: number;
};

export interface IPortalRole {
    portal_role_id: number;
    PortalRoleName: string;
}

class PermissionsStore {

    @observable
    public allPermissionList: IPermissionFullInfo[];

    @observable
    public allPortalRoles: IPortalRole[];

    @observable
    public portal_roles_loaded: boolean = false;

    constructor() {
        // this.getAllPortalRoles();
    }

    @action
    public updateRolePermission = (permission_id: number, role_id: number, active: number) => {
        this.allPermissionList = this.allPermissionList.map((permission_info) => {
            if (permission_info.permission_id === permission_id) {
                return {
                    ...permission_info,
                    ActiveRoleList: permission_info.ActiveRoleList.map((permission_role_info) => {
                        if (permission_role_info.role_id === role_id) {
                            return {
                                ...permission_role_info,
                                Active: active,
                            };
                        } else {
                            return permission_role_info;
                        }
                    })
                }
            } else {
                return permission_info
            }
        })
    }

    @action
    public getAllPermissionList = async () => {
        const response: Response = await fetch(
            config.BASE_URL + '/api/permissions/full_list',
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: authStore.currentUser.SessionKey || "",
                },
                method: "GET",
            }
        );
        const responseJson = await response.json();
        this.allPermissionList = responseJson.body;
    }

    @action
    public getAllPortalRoles = async () => {
        const response: Response = await fetch(
            config.BASE_URL + '/api/permissions/portal_roles',
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    // Authorization: authStore.currentUser.SessionKey || "",
                },
                method: "GET",
            }
        );
        const responseJson = await response.json();
        this.allPortalRoles = responseJson.body;
        this.portal_roles_loaded = true;
    }

    @action
    public savePermissions = async () => {
        const permissions = this.allPermissionList
        const response: Response = await fetch(
            config.BASE_URL + "/api/permissions/save",
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify({
                    permissions
                }),
            }
        );
        const responseJson = await response.json();
        if (responseJson.success) {
            window.location.reload()
        }
    };

    public checkPermissionByCategoryAndType = (category: string, type: string) => {
        if (authStore.currentUser.PermissionsList
            .filter((permission: any) =>
                permission.PermissionCategory === category &&
                permission.PermissionType === type).length > 0) {
            return true
        }
        return false
    }

    public checkContentPermissions = (portal_role_id: number, authCompanies: any, authSites: any,loadedUserportal_role_id:any, content_company_ids: number[], content_site_ids: number[]) => {
        if (portal_role_id === 1 || portal_role_id === 2) {
            return true;
        }
        let company_id = 0;
        if (authCompanies.length > 0) {
            company_id = authCompanies?.find((c: any) => c.Active === 1)?.company_id; //D-011
        }
        if(portal_role_id <= loadedUserportal_role_id){
            return true
        }

        let site_id = 0;
        if (authSites.length > 0) {
            site_id = authSites.find((s: any) => s.Active === 1).siteId;
        }
        else if (portal_role_id === 3 && content_company_ids.includes(company_id)) {
            return true;
        }
        else if (portal_role_id === 4 && content_site_ids.includes(site_id)) {
            return true;
        }
        return false;
    }
}



export default new PermissionsStore();


// WEBPACK FOOTER //
// ./src/modules/admin/modules/Permissions/permissionsStore.ts